import { camelCase } from 'lodash';
import { registerVueAsset } from 'framework/base/registry';

/**
 * Registry contexts
 *
 * This list contains all the different parts of our code which we want to auto-load.
 * At the moment, these are mostly vue-related parts, but this may change in the future.
 * The registry contexts are an async collection of `require.context` webpack calls,
 * which can be split into separate bundles for convenience.
 *
 * @type {Array}
 */
export const contexts = [
    // Enable this feature only if you really need it:
    Promise.resolve({
        loadContext: () => require.context('@dreipol/vue-ui/src/components', true, /[a-zA-Z0-9-]+\.vue$/),
        register: (acc, config) => registerVueAsset(config, { namespace: 'dyn-ui', type: 'component' }),
    }),
    Promise.resolve({
        loadContext: () => require.context('framework/global-components', true, /[a-zA-Z0-9-]+\.vue$/),
        register: (acc, config) => registerVueAsset(config, { namespace: 'dyn', type: 'component' }),
    }),
    Promise.resolve({
        loadContext: () => require.context('framework/filters', true, /[a-zA-Z0-9-]+\/index\.js$/),
        register: (acc, config) => registerVueAsset(config, { convertName: camelCase, type: 'filter' }),
    }),
    Promise.resolve({
        loadContext: () => require.context('@dreipol/vue-ui/src/filters', true, /[a-zA-Z0-9-]+\/index\.js$/),
        register: (acc, config) => registerVueAsset(config, { convertName: camelCase, type: 'filter' }),
    }),
];

if (window.styleguide) {
    contexts.push(Promise.resolve({
        loadContext: () => require.context('framework/styleguide', true, /[a-zA-Z0-9-]+\.vue$/),
        register: (acc, config) => registerVueAsset(config, { namespace: 'dyn-sty', type: 'component' }),
    }));
}
